import { useReactiveVar } from '@apollo/client'
import { reactiveWorkspaceActions } from 'api/graphQL/reactiveVars/workspaceActions'
import { ActionButton } from 'components/ActionBar'
import InsertPillIcon from 'components/Workspace2ActionBar/InsertPillIcon'
import InsertSpecifierNoteIcon from 'components/Workspace2ActionBar/InsertSpecifierNoteIcon'
import InsertTextFieldIcon from 'components/Workspace2ActionBar/InsertTextFieldIcon'
import InsertUOMIcon from 'components/Workspace2ActionBar/InsertUOMIcon'
import { useEditorActionBarHandler } from 'components/WorkspaceEditor/hooks/useEditorActionBarHandler'
import { useWorkspace2ActionBarStyles } from 'components/WorkspaceEditor/styles/useWorkspace2ActionBarStyles'
import {
    ActionButtonVariant,
    PROPERTY_EDITOR_SHORTCUT_KEY_MAPPING as ShortcutKeys,
} from 'pages/ProjectsPage/WorkspacePage/components/constants'
import React from 'react'
interface SMMActionButtonsProps {
    isNewWorkspaceActionButton?: boolean
}
const SMMActionButtons = ({
    isNewWorkspaceActionButton = false,
}: SMMActionButtonsProps) => {
    const {
        isAddSpecifierNote,
        isInsertPill,
        isInsertText,
        isInsertUOM,
    } = useReactiveVar(reactiveWorkspaceActions)

    const {
        handleAddSpecifierNote,
        handleInsertPill,
        handleInsertText,
        handleInsertUOM,
    } = useEditorActionBarHandler()

    const { iconButton, iconButtonDisabled } = useWorkspace2ActionBarStyles({
        isOMorSMM: true,
    })
    return (
        <>
            <ActionButton
                onClick={handleInsertPill}
                disabled={!isInsertPill}
                variant={ActionButtonVariant.InsertPill}
                tooltip={{
                    label: 'Insert Pill',
                    smallLabel: ShortcutKeys.InsertPill,
                }}
                iconOverlaySize={isNewWorkspaceActionButton ? 22 : 26}
                aria-label="Insert Pill"
            >
                <InsertPillIcon
                    className={isInsertPill ? iconButtonDisabled : iconButton}
                    fontSize="inherit"
                />
            </ActionButton>
            <ActionButton
                onClick={handleInsertText}
                disabled={!isInsertText}
                variant={ActionButtonVariant.InsertText}
                tooltip={{
                    label: 'Insert Text Field',
                    smallLabel: ShortcutKeys.InsertText,
                }}
                iconOverlaySize={isNewWorkspaceActionButton ? 22 : 26}
                aria-label="Insert Text Field"
            >
                <InsertTextFieldIcon
                    className={isInsertText ? iconButtonDisabled : iconButton}
                    fontSize="inherit"
                />
            </ActionButton>
            <ActionButton
                onClick={handleInsertUOM}
                disabled={!isInsertUOM}
                variant={ActionButtonVariant.InsertUOM}
                tooltip={{
                    label: 'Insert Unit of Measure',
                    smallLabel: ShortcutKeys.InsertUOM,
                }}
                iconOverlaySize={isNewWorkspaceActionButton ? 22 : 26}
                aria-label="Insert Unit of Measure"
            >
                <InsertUOMIcon
                    className={isInsertUOM ? iconButtonDisabled : iconButton}
                    fontSize="inherit"
                />
            </ActionButton>
            <ActionButton
                onClick={handleAddSpecifierNote}
                disabled={!isAddSpecifierNote}
                variant={ActionButtonVariant.SpecifierNote}
                tooltip={{
                    label: 'Add Specifier Note',
                    smallLabel: ShortcutKeys.AddSpecifierNote,
                }}
                iconOverlaySize={isNewWorkspaceActionButton ? 22 : 26}
                aria-label="Add Specifier Note"
            >
                <InsertSpecifierNoteIcon
                    className={
                        isAddSpecifierNote ? iconButtonDisabled : iconButton
                    }
                    fontSize="inherit"
                />
            </ActionButton>
        </>
    )
}
export default SMMActionButtons
